<template>
    <div class="scroll-table">
        <div class="table-responsive text-nowrap">
            <table class="table table-striped" :class="{ 'table-fixed': !detailed }">
                <thead>
                <tr>
                    <th v-for="({name, type,valueKey}, index) in options.data"
                        :key="index"
                        :class="{'th-first': index === 0, 'th-last': index === lastIndex, 'text-right': isNumericType(type) }"
                    >
                        {{ name }}
                    </th>
                </tr>
                </thead>

                <tbody>
                <tr
                    v-for="(item, index) in data"
                    :key="index"
                    :class="index % 2 === 0 ? 'row-odd' : 'row-even'"
                >
                    <td v-for="({valueKey, type, value, wrap}, index) in options.data"
                        :key="index"
                        :class="{'text-right': isNumericType(type)}"
                        class="td-padding"
                    >
                        <template v-if="wrap">
                            <template v-for="(line, lineIndex) in wrapLines(value ? value : item[valueKey], wrap)"><br v-if="lineIndex > 0" :key="'br' + lineIndex">{{ line }}</template>
                        </template>
                        <template v-else>{{ format(value ? value : item[valueKey], type) }}</template>
                    </td>
                </tr>
                </tbody>

                <thead>
                <tr v-if="options.summary">
                    <th v-for="({valueKey, type, name}, index) in options.summary"
                        :key="index"
                        :class="{'th-first': index === 0, 'th-last': index === lastIndex, 'text-right': isNumericType(type) }"
                    >
                        {{ name !== undefined ? name : format(summary[valueKey], type) }}
                    </th>
                </tr>
                </thead>
            </table>
        </div>
    </div>

</template>

<script>
import TableCellText from "../../services/TableCellText";

export default  {
    name: "DataTable",
    props: {
        data: {
            type: Array|Object,
            required: true,
        },
        options: {
            type: Object,
            required: true,
        },
        summary: {
            type: Object,
            default: null,
        },
        detailed:{
            type: Boolean,
            default:false
        }

    },
    computed: {
        lastIndex() {
            return this.options.data.length - 1;
        },
    },
    methods: {
        format(value, type = null) {
            if ((type && value) || (type && value === 0)) {
                return this.$options.filters[type](value);
            }
            if(value == null && type == ''){
                return '';
            }
            return value ?? '-';
        },
        // kolumna z "wrap: N" lamie tekst co N znakow (table-responsive ma text-nowrap)
        wrapLines(value, lineMax) {
            const lines = TableCellText.lines(value, lineMax);
            return lines.length ? lines : ['-'];
        },
        isNumericType(type) {
            return ['money'].includes(type);
        },
    },
};
</script>
